"use client";

import { c as _c } from "react/compiler-runtime";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { tv } from "tailwind-variants";
import { Check } from "../../icons/material-symbols/outlined/Check";
import { HorizontalRule } from "../../icons/material-symbols/outlined/HorizontalRule";
import { disabledVariants } from "../../styles";
import { disabledWrapperVariants } from "../../styles/utils/disabledWrapper";
import { classNames } from "../../utils";
const checkboxVariants = tv({
  base: classNames("size-4 min-h-4 min-w-4 rounded border outline-hidden transition-colors duration-150",
  // Only show focus border when keyboard is used, not on mouse click
  "focus:border-border-3 [&:not(:focus-visible)]:border-border-2"),
  variants: {
    checked: {
      false: "border-border-2 bg-bg-primary",
      true: "border-0 bg-blue-3",
      indeterminate: "border-0 bg-blue-3"
    }
  }
});

/**
 * A control that allows the user to toggle between checked and not checked.
 */
export function Checkbox(t0) {
  const $ = _c(27);
  let className;
  let disabled;
  let onCheckedChange;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      checked: t1,
      disabled,
      onCheckedChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = disabled;
    $[3] = onCheckedChange;
    $[4] = props;
    $[5] = t1;
  } else {
    className = $[1];
    disabled = $[2];
    onCheckedChange = $[3];
    props = $[4];
    t1 = $[5];
  }
  const checked = t1 === undefined ? false : t1;
  const Icon = checked === "indeterminate" ? HorizontalRule : Check;
  let t2;
  if ($[6] !== disabled) {
    t2 = classNames(disabledWrapperVariants({
      disabled
    }));
    $[6] = disabled;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== checked || $[9] !== className || $[10] !== disabled) {
    t3 = classNames(checkboxVariants({
      checked
    }), disabledVariants({
      disabled
    }), className);
    $[8] = checked;
    $[9] = className;
    $[10] = disabled;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== checked || $[13] !== onCheckedChange) {
    t4 = () => {
      onCheckedChange?.(!checked);
    };
    $[12] = checked;
    $[13] = onCheckedChange;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== Icon) {
    t5 = <CheckboxPrimitive.Indicator className="flex items-center justify-center"><Icon fill="white" size={14} /></CheckboxPrimitive.Indicator>;
    $[15] = Icon;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== checked || $[18] !== disabled || $[19] !== props || $[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t6 = <CheckboxPrimitive.Root checked={checked} className={t3} disabled={disabled} onCheckedChange={t4} {...props}>{t5}</CheckboxPrimitive.Root>;
    $[17] = checked;
    $[18] = disabled;
    $[19] = props;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t2 || $[25] !== t6) {
    t7 = <span className={t2}>{t6}</span>;
    $[24] = t2;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}